/**
 * TypeScript requires us to declare any properties we add to the global 'window' object.
 * This tells the compiler that 'window.OCA' is a valid and expected property,
 * preventing a compile-time error.
 */
declare global {
    interface Window {
        OCA: any;
    }
}

// -------------------------------------------------------------------
// STEP 1: Change your exports to local imports.
// This brings the class and configuration object into this file's scope.
// -------------------------------------------------------------------

import { ResponsiveMap } from "./usmap/map-interact";
import { mymap_config } from "./usmap/map-config";


// -------------------------------------------------------------------
// STEP 2: Manually expose your code to the global scope.
// This explicitly creates the global OCA.map_js object and attaches your code to it.
// -------------------------------------------------------------------

// Ensure the global OCA object exists, creating it if it doesn't.
window.OCA = window.OCA || {};

// Assign your imported code to the 'map_js' property on the OCA object.
window.OCA.map_js = {
    ResponsiveMap: ResponsiveMap,
    mymap_config: mymap_config
};